import { useEffect } from 'react';

const useHorizonalTabs = (isLight) => {
  useEffect(() => {
    var horizontalTabs = (function () {
      /**
       * Constructor for Horizontal Tabs
       *
       * return {void}
       */
      function horizontalTabs(widgets) {
        const $panelNav = widgets; // $(this);
        const $panelNavItems = $panelNav.querySelectorAll('.c-horizontal-tabs-panelNav-tab'); // $panelNav.find("a");
        const $panelContainer = document.querySelector('#' + $panelNav.dataset.panelwrapper); // $("#" + $panelNav.data("panelwrapper"));
        const $panels = $panelContainer.querySelectorAll('.panel'); // $panelContainer.find("> .panel"),
        const numPanels = $panels.length;
        const animationDuration = $panelContainer.dataset.sequential === 'yes' ? 600 : 300; // $panelContainer.data("sequential") == "yes" ? 600 : 300;

        if (!$panelNavItems.length) {
          return;
        }

        $panelNavItems[0].classList.add('is-active');

        if (numPanels > 1) {
          var hrefNext = $panelNav.querySelector('a[href="#next"]');
          if (hrefNext !== null) {
            hrefNext.classList.remove('inactive'); //$panelNav.find('a[href="#next"]').removeClass("inactive");
          }
        }

        for (var clickIndex = 0; clickIndex < numPanels; clickIndex++) {
          $panelNavItems[clickIndex].addEventListener('keypress', function (e) {
            var keyCode = e.keyCode ? e.keyCode : e.which;
            if (keyCode === 13) {
              this.click();
            }
          });

          $panelNavItems[clickIndex].addEventListener('click', function (e) {
            for (var i = 0; i < $panelNavItems.length; i++) {
              $panelNavItems[i].classList.remove('is-active');
            }
            this.classList.add('is-active');

            var $panelToSlideIn, $panelToSlideOut, enterAnimation, exitAnimation;

            // Don't do anything if we are currently animating
            if ($panelContainer.classList.contains('animating')) return;

            // Define the panel to slideOut
            $panelToSlideOut = $panelContainer.querySelector('.current'); // $panels.filter(".current");

            // Define the the panel to slide in
            // if ($(this).attr("href") == "#next") {
            //     $panelToSlideIn = $panels.filter(".current").next(".panel");
            // } else if ($(this).attr("href") == "#prev") {
            //     $panelToSlideIn = $panels.filter(".current").prev(".panel");
            // } else {
            //     $panelToSlideIn = $($(this).attr("href"))
            // }

            if (this.getAttribute('href') === '#next') {
              $panelToSlideIn = $panelContainer.querySelector('#' + this.dataset.panel);
            } else if (this.getAttribute('href') === '#prev') {
              $panelToSlideIn = $panelContainer.querySelector('#' + this.dataset.panel);
            } else {
              $panelToSlideIn = $panelContainer.querySelector('#' + this.dataset.panel);
            }

            // Don't do anything if there is no new panel
            if ($panelToSlideIn === null || $panelToSlideOut === null) return; //if (!$panelToSlideIn.size()) return;

            // Don't do anything if the new panel equals the current panel
            if ($panelToSlideOut.id == $panelToSlideIn.id) return;

            // Define animations to use
            enterAnimation = $panelToSlideIn.dataset.enter || $panelContainer.dataset.enter;
            exitAnimation = $panelToSlideOut.dataset.exit || $panelContainer.dataset.exit;

            // Set the exit panel
            setExitPanel($panelToSlideOut, exitAnimation);

            // Set the enter panel
            setEnterPanel($panelContainer, $panels, $panelToSlideIn, enterAnimation);

            // Start the animation (immediately)
            // @note: using a setTimeout because "it solves everything", dixit @rem
            setTimeout(function () {
              startAnimation($panelContainer);
            }, 0);

            // Update next/prev buttons
            updatePanelNav($panelNav, $panelContainer, $panelToSlideIn, numPanels);

            // Stop the animation after a while
            setTimeout(function () {
              stopAnimation($panelContainer, $panels, $panelToSlideIn);
            }, animationDuration);
          });
        }
      }

      var startAnimation = function ($panelContainer) {
        $panelContainer.classList.add('animating');
      };

      var updatePanelNav = function ($panelNav, $panelContainer, $panelToSlideIn, numPanels) {
        return;

        // Find index of $panelToSlideIn in the $panelContainer
        var idx = $panelToSlideIn.index('#' + $panelContainer.attr('id') + ' > .panel');

        if (idx === 0) {
          $panelNav.find('a[href="#prev"]').addClass('inactive');
        } else {
          $panelNav.find('a[href="#prev"]').removeClass('inactive');
        }

        if (idx == numPanels - 1) {
          $panelNav.find('a[href="#next"]').addClass('inactive');
        } else {
          $panelNav.find('a[href="#next"]').removeClass('inactive');
        }
      };

      var stopAnimation = function ($panelContainer, $panels, $panelToSlideIn) {
        // Fix for browsers who fire this handler for both prefixed and unprefixed events (looking at you, Chrome): remove any listeners
        // $panelToSlideIn.off('transitionend webkitTransitionEnd	MSTransitionEnd');

        // An optional extra class (or set of classes) that might be set on the panels
        // var extraClass = $panelContainer.data("extraclass") || "";
        var extraClass = ($panelContainer.dataset.extraclass || '').split(' ');

        // set slid in panel as the current one
        //$panelToSlideIn.removeClass().addClass("panel current " + extraClass);
        var ClassNameList = ['panel', 'current'].concat(extraClass);
        $panelToSlideIn.setAttribute('class', '');
        ClassNameList.forEach(function (className) {
          if (className === '') return;
          $panelToSlideIn.classList.add(className);
        });
        //$panelToSlideIn.classList.add.apply($panelToSlideIn.classList, extraClass);

        // reset all other panels
        // $panels
        //   .filter(":not(#" + $panelToSlideIn.attr("id") + ")")
        //   .removeClass()
        //   .addClass("panel " + extraClass);

        var ClassNameList = ['panel'].concat(extraClass);
        $panels.forEach(function (element) {
          if (element.id === $panelToSlideIn.id) return;
          element.setAttribute('class', '');
          ClassNameList.forEach(function (className) {
            if (className === '') return;
            element.classList.add(className);
          });
        });

        // Allow a new animation
        // $panelContainer.removeClass("animating");
        $panelContainer.classList.remove('animating');
      };

      var setExitPanel = function ($panelToSlideOut, exitAnimation) {
        //$panelToSlideOut.addClass("exit " + exitAnimation).removeClass("current");
        $panelToSlideOut.classList.add.apply(
          $panelToSlideOut.classList,
          exitAnimation.split(' ').concat('exit')
        );
        $panelToSlideOut.classList.remove('current');
      };

      var setEnterPanel = function ($panelContainer, $panels, $panelToSlideIn, enterAnimation) {
        // Slide it into view
        // $panelToSlideIn.addClass("enter " + enterAnimation);
        $panelToSlideIn.classList.add.apply(
          $panelToSlideIn.classList,
          enterAnimation.split(' ').concat('enter')
        );

        // When sliding in is done,
        // .one('transitionend webkitTransitionEnd MSTransitionEnd', function(e) {

        // moved to a setTimeout in the click handling logic itself because Firefox doesn't always fire this!!!
        // stopAnimation($panelContainer, $panels, $panelToSlideIn)

        // })
      };

      return horizontalTabs;
    })();

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var widgets = document.getElementsByClassName('c-horizontal-tabs');

      for (var i = 0; i < widgets.length; i++) {
        new horizontalTabs(widgets[i]);
      }
    }
  }, [isLight]);
};

export default useHorizonalTabs;
